var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('a-alert',{attrs:{"message":_vm.message,"type":_vm.type,"show-icon":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }